import { useState } from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import { Plus, Minus } from 'lucide-react'

const faqItems = [
  {
    question: 'Как подключаем оплату в боте?',
    answer: 'Интегрируем популярные платёжные системы ЮKassa, CloudPayments и другие. Бот автоматически формирует счета, принимает оплату, отправляет чеки и выдаёт доступ к услуге сразу после успешного платежа.'
  },
  {
    question: 'С какими CRM-системами работаем?',
    answer: 'Мы настраиваем интеграции с Bitrix24, amoCRM, 1С и другими сервисами. Все заявки из бота автоматически попадают в вашу CRM с полной информацией о клиенте, источнике и этапе воронки продаж.'
  },
  {
    question: 'Как считаем отчёты и аналитику?',
    answer: 'Создаём единый дашборд с ключевыми метриками: количество лидов, конверсия, платежи, среднее время обработки. Настраиваем ежедневные выгрузки в email или Google Sheets, а также экспорт в CSV/Excel.'
  },
  {
    question: 'Как обеспечиваем безопасность данных?',
    answer: 'Используем систему ролей и прав доступа, полное логирование всех действий, защиту вебхуков шифрованием, регулярные бэкапы. Все данные хранятся с соблюдением требований безопасности.'
  },
  {
    question: 'Сколько времени занимает разработка?',
    answer: 'MVP-версию можем запустить за 1-2 недели. Стандартный проект с интеграциями занимает 3-4 недели. Сложные корпоративные решения обсуждаются индивидуально.'
  },
  {
    question: 'Предоставляете ли техническую поддержку?',
    answer: 'Да, мы предоставляем платную техподдержку. Ваш бот будет всегда онлайн и под присмотром профессионалов 24/7.'
  }
]

export default function TelegramFAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null)

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index)
  }

  return (
    <section className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            Ответы на вопросы
          </h2>
          <p className="text-xl text-gray-600">
            Самые частые вопросы о разработке и интеграции Telegram-ботов
          </p>
        </motion.div>

        <div className="space-y-4">
          {faqItems.map((item, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.05 }}
              className="bg-white rounded-xl shadow-md overflow-hidden border border-gray-200 hover:shadow-lg transition-shadow"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full px-8 py-6 flex items-center justify-between text-left hover:bg-gray-50 transition-colors"
                aria-expanded={openIndex === index}
              >
                <span className="text-lg font-semibold text-gray-900 pr-8">
                  {item.question}
                </span>
                <div className="flex-shrink-0">
                  {openIndex === index ? (
                    <Minus className="w-6 h-6 text-blue-600" />
                  ) : (
                    <Plus className="w-6 h-6 text-gray-400" />
                  )}
                </div>
              </button>

              <AnimatePresence>
                {openIndex === index && (
                  <motion.div
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: 'auto', opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.3 }}
                    className="overflow-hidden"
                  >
                    <div className="px-8 pb-6 text-gray-600 leading-relaxed">
                      {item.answer}
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  )
}
